import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { AppService } from 'src/app/services/services';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { EncryptionService } from 'src/app/services/encryption.service';
import { FileUploadComponent } from 'src/app/common/file-upload/file-upload.component';
import { AutocompleteComponent } from 'angular-ng-autocomplete';
import { ErrorModalComponent } from 'src/app/common/error-modal/error-modal.component';

@Component({
  selector: 'nri-app-bank',
  templateUrl: './bank.component.html',
  styleUrls: ['./bank.component.scss'],
})
export class BankComponent implements OnInit {
  @Output() stageComplete = new EventEmitter();
  erefNo: string = '';
  panNumber: string = '';
  nrePIS: boolean;
  nreNPIS: boolean;
  nroPIS: boolean;
  nroNPIS: boolean;
  nrepisUpdt: boolean;
  nrepisImgempty: boolean;
  nrenpisImgempty: boolean;
  nrenpisUpdt: boolean;
  nropisUpdt: boolean;
  nropisImgempty: boolean;
  nronpisUpdt: boolean;
  nronpisImgempty: boolean;
  agreeBankStage: boolean = false;
  nropisac: string = '';
  nrepisac: string = '';
  nronpisac: string = '';
  nrenpisac: string = '';
  getnreNPIS: boolean = false;
  getnrePIS: boolean = false;
  getnroNPIS: boolean = false;
  getnroPIS: boolean = false;
  nronpisacError: boolean;
  nropisacError: boolean;
  nrenpisacError: boolean;
  nrepisacError: boolean;
  existingDemat: boolean;
  referenceNo: any;
  referenceNoErrorMsg: boolean = false;
  FandO: boolean = false;
  disableBank: boolean = false;
  getnre: boolean = false;
  getnro: boolean = false;
  getPIS: boolean = false;
  getNonPIS: boolean = false;
  nre: boolean = false;
  nreBank: string = '';
  nreAccountNo: string = '';
  nreMicr: string = '';
  nreIfscCode: string;
  nreReferenceNo: string;
  nro: boolean = false;
  nroBank: string = '';
  nroAccountNo: string = '';
  confirmnroAccountNo: string = '';
  confirmnonPisAccountNo: string = '';
  nroMicr: string = '';
  nroIfscCode: string;
  nroReferenceNo: string;
  pis: boolean = false;
  pisBank: string = '';
  pisAccountNo: string = '';
  pisMicr: string = '';
  pisIfscCode: string;
  pisReferenceNo: string;
  nonPis: boolean = false;
  nonPisBank: string = '';
  nonPisAccountNo: string = '';
  nonPisMicr: string = '';
  nonPisIfscCode: string;
  nonPisReferenceNo: string;
  @ViewChild('nrepisimg') nreImage: FileUploadComponent;
  @ViewChild('nrenpisimg') nroImage: FileUploadComponent;
  @ViewChild('nropisimg') pisImage: FileUploadComponent;
  @ViewChild('nronpisimg') nonPisImage: FileUploadComponent;
  @ViewChild('autocomplete') autocomplete: AutocompleteComponent;
  public bankIfsc: any = [];
  focusInp: boolean = false;
  keyword: string = 'IFSC';
  nreifsc: any;
  bankList: any;
  bankList3: any;
  bankList2: any;
  bankList1: any;
  convertNRI: boolean = false;
  branchAddress1: string = '';
  branchAddress2: string = '';
  branchAddress3: string = '';
  nreAccountName: string = '';
  nomineeStatus: boolean = false;
  branchName: string = '';
  branchName1: string = '';
  shownreAccount: boolean = false;
  shownreConAccount: boolean = false;
  shownroAccount: boolean = false;
  shownroConAccount: boolean = false;
  checkNreAcc: boolean = false;
  checkNroAcc: boolean = false;
  bothAccountErr: boolean = false;
  NRO1: string = '';
  @ViewChild('errorComp') errorComp: ErrorModalComponent;

  constructor(
    private _http: AppService,
    private loader: NgxUiLoaderService,
    private http: EncryptionService,
    private router: Router,
    private toastr: ToastrService,
  ) {
    this._http.getRefNum().subscribe((data) => {
      this.erefNo = data;
    });

    this._http.getStatus().subscribe((data) => {
      this.panNumber = data.Pan;
    });

    this._http.getBank().subscribe((data: any) => {
      this.FandO = data.FandO;
      if (this.FandO === true) {
        this.nroNPIS = true;
        this.disableBank = true;
      }
    });
  }

  ngOnInit() {
    this.getBankInfo();
    if (sessionStorage.getItem('NRO') === 'Y') {
      this.nro = true;
      this.NRO1 = 'Y';
    }
    setTimeout(() => {
      this.overallStatus();
    }, 1000);
    this._http.scroll();
  }

  checkAccountNumber(bankName: string) {
    if (bankName === 'NRE') {
      this.checkNreAcc = this.nroAccountNo !== this.confirmnroAccountNo;
    } else if (bankName === 'NRO') {
      this.checkNroAcc = this.nonPisAccountNo !== this.confirmnonPisAccountNo;
      if (this.nro) {
        this.bothAccountErr = this.nroAccountNo === this.nonPisAccountNo;
      }
    }
  }

  selectEvent(item: string, bankName: string) {
    if (item) {
      this.loader.start();
      this._http.getMICR(item).subscribe((data: any) => {
        this.loader.stop();
        // console.log(data.IFSCInfo);
        if (data && data.IsSuccess) {
          if (bankName === 'NRONPIS') {
            this.bankList3 = data.IFSCCodes;
            if (this.bankList3.length === 1) {
              this.nonPisMicr = this.bankList3[0].MICRCODE;
              this.addressBind(this.nonPisMicr, 'NRONPIS');
            } else if (this.bankList3.length > 1) {
              this.nonPisMicr = this.bankList3[0].MICRCODE;
              this.addressBind(this.nonPisMicr, 'NRONPIS');
            }
          } else if (bankName === 'NROPIS') {
            this.bankList2 = data.IFSCCodes;
            if (this.bankList2.length === 1) {
              this.pisMicr = this.bankList2[0].MICRCODE;
              this.addressBind(this.pisMicr, 'NROPIS');
            } else if (this.bankList2.length > 1) {
              this.pisMicr = this.bankList2[0].MICRCODE;
              this.addressBind(this.pisMicr, 'NROPIS');
            }
          } else if (bankName === 'NRENPIS') {
            // this.bankList1 = data.IFSCCodes;
            // if (this.bankList1.length === 1) {
            //     this.nroMicr = this.bankList1[0].MICRCODE;
            //     this.addressBind(this.nroMicr, "NRENPIS")
            // }
            // else if (this.bankList1.length > 1) {
            //     this.nroMicr = this.bankList1[0].MICRCODE;
            //     this.addressBind(this.nroMicr, "NRENPIS")
            // }
            this.bankList1 = data.IFSCCodes;
            const selectedBank = this.bankList1.find(
              (x: any) => x.MICRCODE === this.nroMicr,
            );
            if (selectedBank) {
              this.nroMicr = selectedBank.MICRCODE;
              this.addressBind(this.nroMicr, 'NRENPIS');
            }
            // if (!this.nroMicr) {
            //   this.nroMicr = this.bankList1[0].MICRCODE;
            // }
            // this.addressBind(this.nroMicr, 'NRENPIS');
          } else if (bankName === 'NREPIS') {
            this.bankList = data.IFSCCodes;
            if (this.bankList.length === 1) {
              this.nreMicr = this.bankList[0].MICRCODE;
              this.addressBind(this.nreMicr, 'NREPIS');
            } else if (this.bankList.length > 1) {
              this.nreMicr = this.bankList[0].MICRCODE;
              this.addressBind(this.nreMicr, 'NREPIS');
            }
          }
        } else {
          this.errorComp.ModalShow('Please Contact Admin');
          // this.toastr.error("Please Contact Admin");
        }
      });
    }
  }

  onChangeSearch(search: string, bankName: string) {
    //1st bank nre
    if (search) {
      if (bankName === 'NREPIS') {
        this._http.getIFSC(search).subscribe({
          next: (data: any) => {
            if (data && data.IFSCCodes) {
              let ifsc: any = [];
              data.IFSCCodes.forEach((element: any) => {
                ifsc.push(element.IFSCCodes);
                this.bankIfsc = [...new Set(ifsc)];
              });
            }
          },
        });
      }
      //2st bank nro
      else if (bankName === 'NRENPIS') {
        this._http.getIFSC(search).subscribe({
          next: (data: any) => {
            if (data && data.IFSCCodes) {
              let ifsc: any = [];
              data.IFSCCodes.forEach((element: any) => {
                ifsc.push(element.IFSCCodes);
                this.bankIfsc = [...new Set(ifsc)];
              });
            }
          },
        });
      }
      //3st bank nro pis
      else if (bankName === 'NROPIS') {
        this._http.getIFSC(search).subscribe({
          next: (data: any) => {
            if (data && data.IFSCCodes) {
              let ifsc: any = [];
              data.IFSCCodes.forEach((element: any) => {
                ifsc.push(element.IFSCCodes);
                this.bankIfsc = [...new Set(ifsc)];
              });
            }
          },
        });
      }
      //4th bank nro pis
      else if (bankName === 'NRONPIS') {
        this._http.getIFSC(search).subscribe({
          next: (data: any) => {
            if (data && data.IFSCCodes) {
              let ifsc: any = [];
              data.IFSCCodes.forEach((element: any) => {
                ifsc.push(element.IFSCCodes);
                this.bankIfsc = [...new Set(ifsc)];
                // this.bankIfsc.push(element.IFSCCodes);
              });
            }
          },
        });
      }
    }

    // fetch remote data from here
    // And reassign the 'data' which is binded to 'data' property.
  }

  onFocused(e: any) {
    // do something
    if (e) {
      this.focusInp = true;
    }
  }

  addressBind(value: any, bankName: string) {
    // console.log(value);
    let micrList;
    if (bankName === 'NRONPIS') {
      micrList = this.bankList3;
    } else if (bankName === 'NROPIS') {
      micrList = this.bankList2;
    } else if (bankName === 'NRENPIS') {
      micrList = this.bankList1;
    } else if (bankName === 'NREPIS') {
      micrList = this.bankList;
    }
    const matchingData = micrList.find((data: any) => data.MICRCODE === value);
    if (matchingData) {
      if (bankName === 'NRONPIS') {
        this.nonPisBank = matchingData.BankName;
        this.branchAddress3 = matchingData.Address;
        // this.branchName1 =matchingData.BranchName
      } else if (bankName === 'NROPIS') {
        this.pisBank = matchingData.BankName;
      } else if (bankName === 'NRENPIS') {
        this.nroBank = matchingData.BankName;
        this.branchAddress2 = matchingData.Address;
        // this.branchName =matchingData.BranchName;
      } else if (bankName === 'NREPIS') {
        this.nreBank = matchingData.BankName;
        this.branchAddress1 = matchingData.Address;
      }
    } else {
      if (bankName === 'NREPIS') {
        this.nreBank = '';
        this.branchAddress1 = '';
      } else if (bankName === 'NRENPIS') {
        this.nroBank = '';
        this.branchAddress2 = '';
      } else if (bankName === 'NROPIS') {
        this.pisBank = '';
      } else if (bankName === 'NRONPIS') {
        this.nonPisBank = '';
        this.branchAddress3 = '';
      }
    }
  }
  deletebank(bankName: string) {
    if (bankName === 'NRONPIS') {
      this.nonPisBank = '';
      this.nonPisMicr = '';
      this.bankList3 = [];
    } else if (bankName === 'NROPIS') {
      this.pisBank = '';
      this.pisMicr = '';
      this.bankList2 = [];
    } else if (bankName === 'NRENPIS') {
      this.nroBank = '';
      this.nroMicr = '';
      this.bankList1 = [];
    } else if (bankName === 'NREPIS') {
      this.nreBank = '';
      this.nreMicr = '';
      this.bankList = [];
    }
  }

  getBankInfo() {
    let url = 'DIY/DIYGetBankInfo';
    let params = {
      ReferenceNumber: this.erefNo,
    };
    let checkSum = this.erefNo;
    this.loader.start();
    this._http.httpPost(url, params, checkSum).subscribe({
      next: (data: any) => {
        this.loader.stop();
        let val = this.http.decryptUsingAES256(data.OutPut);
        if (val) {
          this.nomineeStatus = val.IsNominee;
        }
        if (
          val &&
          val.APP_RES_STATUS &&
          val.APP_RES_STATUS.toUpperCase() === 'R'
        ) {
          this.nro = true;
          this.convertNRI = true;
        }
        if (val && val.IsSuccess) {
          this.agreeBankStage = true;
          this.existingDemat = val.ExistingDemat;
          this.nre = val.NRE === 'Y' ? true : false;
          if (val.APP_RES_STATUS.toUpperCase() !== 'R') {
            this.nro = val.NRO === 'Y' ? true : false;
          }
          this.pis = val.PIS === 'Y' ? true : false;
          this.nonPis = val.NONPIS === 'Y' ? true : false;

          if (val.NRE) {
            this.getnre = true;
          }
          if (val.NRO) {
            this.getnro = true;
          }
          if (val.PIS) {
            this.getPIS = true;
          }
          if (val.NONPIS) {
            this.getNonPIS = true;
          }
          if (val.NRE === 'Y') {
            this.nreBank = val.NRE_Bank;
            this.nreIfscCode = val.NRE_IFSC;
            this.nreMicr = val.NRE_MICR;
            this.nreAccountNo = val.NRE_AC;
            this.nreAccountName = val.NRE_AccountHolderName;
            // this.nreReferenceNo = val.NRE_RBIRefNo;
            this.selectEvent(this.nreIfscCode, 'NREPIS');
          }
          if (val.NRO === 'Y') {
            this.nroBank = val.NRO_Bank;
            this.nroIfscCode = val.NRO_IFSC;
            this.nroMicr = val.NRO_MICR;
            this.nroAccountNo = val.NRO_AC;
            this.confirmnroAccountNo = val.ConfirmNRO_AC;
            this.branchName = val.NROBankBranch;
            // this.nroReferenceNo = val.NRO_RBIRefNo;
            this.selectEvent(this.nroIfscCode, 'NRENPIS');
          }
          if (val.PIS === 'Y') {
            this.pisBank = val.PIS_Bank;
            this.pisIfscCode = val.PIS_IFSC;
            this.pisMicr = val.PIS_MICR;
            this.pisAccountNo = val.PIS_AC;
            // this.pisReferenceNo = val.PIS_RBIRefNo;
            this.selectEvent(this.pisIfscCode, 'NROPIS');
          }
          if (val.NONPIS === 'Y') {
            this.nonPisBank = val.NONPIS_Bank;
            this.nonPisIfscCode = val.NONPIS_IFSC;
            this.nonPisMicr = val.NONPIS_MICR;
            this.nonPisAccountNo = val.NONPIS_AC;
            this.confirmnonPisAccountNo = val.ConfirmNONPIS_AC;
            this.branchName1 = val.NONPISNREBankBranch;
            // this.nonPisReferenceNo = val.NONPIS_RBIRefNo;
            this.selectEvent(this.nonPisIfscCode, 'NRONPIS');
          }
        } else {
          if (val.NRE) {
            this.getnre = true;
          }
          if (val.NRO) {
            this.getnro = true;
          }
          if (val.PIS) {
            this.getPIS = true;
          }
          if (val.NONPIS) {
            this.getNonPIS = true;
          }
        }
      },
      error: (error) => {
        this.loader.stop();
      },
    });
  }

  overallStatus() {
    let url = 'DIY/DIYOverallStatus';
    const checkSum = this.erefNo;
    let params = {
      ReferenceNumber: this.erefNo,
    };
    this.loader.start();
    this._http.httpPost(url, params, checkSum).subscribe({
      next: (data: any) => {
        this.loader.stop();
        let val = this.http.decryptUsingAES256(data.OutPut);
        if (val && val.IsSuccess) {
          this.panNumber = val.PanNumber;
          this.NRO1 = val.NRO;
          if (this.NRO1 === 'Y') {
            this.nro = true;
          }
          // this.geAccountTypes();
        }
      },
    });
  }

  // geAccountTypes(){
  //     let url = "DIY/SubAcVerify";

  //     let params = {
  //         "ReferenceNumber": this.erefNo,
  //         "PanNumber": this.panNumber
  //     }

  //     let checkSum = this.erefNo + this.panNumber;

  //     this._http.httpPost(url, params, checkSum).subscribe({
  //         next: (data:any)=>{
  //             let val=this.http.decryptUsingAES256(data.OutPut)
  //             if(val.IsSuccess){
  //                 this.existingDemat = val.ExistingDemat;

  //                 if(val.NRE_NONPIS){
  //                     this.getnre = true;
  //                 }

  //                 if(val.NRE_PIS){
  //                     this.getnro = true;
  //                 }

  //                 if(val.NRO_NONPIS){
  //                     this.getPIS = true;
  //                 }

  //                 if(val.NRO_PIS){
  //                     this.getNonPIS = true;
  //                 }
  //             }
  //             this.getBankInfo();
  //         },
  //         error: _error =>{

  //         }
  //     })
  // }

  typeChange(event: any) {
    // if(event.target.id === "nre" && !this.nomineeStatus){
    //     const message:string = "Nomination is mandatory for PIS NRE bank account selection, Kindly provide nomination details to proceed in the journey.";
    //     this.errorComp.ModalShow(message, true , '/fatca', true);
    // }
    // if(event.target.id === "nro"){
    //     this.nro = true;
    //     this.nonPis = false;
    // }else{
    //     this.nonPis = true;
    //     this.nro = false;
    // }
  }

  spaceValidation(event: any, name: string) {
    const input = event.target.value;
    event.target.value = input.replace(/^\s+|\s+$|\s+(?=\s)/g, '');
  }

  imageURL(event: any) {
    if (event.name === 'NRE' && event.url) {
      this.nrepisUpdt = true;
      this.nrepisImgempty = false;
    } else if (event.name === 'NRO' && event.url) {
      this.nrenpisUpdt = true;
      this.nrenpisImgempty = false;
    } else if (event.name === 'NRO_PIS' && event.url) {
      this.nropisUpdt = true;
      this.nropisImgempty = false;
    } else if (event.name === 'NON_PIS' && event.url) {
      this.nronpisUpdt = true;
      this.nronpisImgempty = false;
    }
  }

  stageValidate() {
    let error = 0;
    if (this.getnro && this.nro) {
      this.branchName = this.branchName.trimStart();
      if (
        !this.nroBank ||
        !this.nroAccountNo ||
        !this.nroMicr ||
        !this.nroIfscCode ||
        !this.confirmnroAccountNo ||
        !this.branchName
      ) {
        error++;
        this.errorComp.ModalShow(
          !this.branchName
            ? 'Please Enter Branch Name'
            : 'Please Fill All the Fields',
        );
        // this.toastr.error("Please Fill All the Fields");
        return;
      } else if (this.nro && !this.nrenpisUpdt) {
        this.nrenpisImgempty = true;
        error++;
      }

      if (this.nroAccountNo && this.nroAccountNo.length < 11) {
        this.errorComp.ModalShow('Account No Min Length is 11');
        // this.toastr.error("Account No Min Length is 11");
        return;
      }
      if (this.nroAccountNo !== this.confirmnroAccountNo) {
        this.errorComp.ModalShow('Account No must be same');
        // this.toastr.error("Account No Min Length is 11");
        return;
      }
    }
    if (this.getnre && this.nre) {
      if (
        !this.nreBank ||
        !this.nreAccountNo ||
        !this.nreMicr ||
        !this.nreIfscCode
      ) {
        error++;
        this.errorComp.ModalShow('Please Fill All the Fields');
        // this.toastr.error("Please Fill All the Fields");
        return;
      } else if (this.nre && !this.nrepisUpdt) {
        this.nrepisImgempty = true;
        error++;
      }

      if (this.nreAccountNo && this.nreAccountNo.length < 11) {
        this.errorComp.ModalShow('Account No Min Length is 11');
        // this.toastr.error("Account No Min Length is 11");
        return;
      }
    }
    if (this.getPIS && this.pis) {
      if (
        !this.pisBank ||
        !this.pisAccountNo ||
        !this.pisMicr ||
        !this.pisIfscCode
      ) {
        error++;
        this.errorComp.ModalShow('Please Fill All the Fields');
        // this.toastr.error("Please Fill All the Fields");
        return;
      } else if (this.pis && !this.nropisUpdt) {
        this.nropisImgempty = true;
        error++;
      }
      if (this.pisAccountNo && this.pisAccountNo.length < 11) {
        this.errorComp.ModalShow('Account No Min Length is 11');
        // this.toastr.error("Account No Min Length is 11");
        return;
      }
    }
    if (this.getNonPIS && this.nonPis) {
      this.branchName1 = this.branchName1.trimStart();
      if (
        !this.nonPisBank ||
        !this.nonPisAccountNo ||
        !this.nonPisMicr ||
        !this.nonPisIfscCode ||
        !this.confirmnonPisAccountNo ||
        !this.branchName1
      ) {
        error++;
        this.errorComp.ModalShow(
          !this.branchName1
            ? 'Please Enter Branch Name'
            : 'Please Fill All the Fields',
        );
        // this.toastr.error("Please Fill All the Fields");
        return;
      } else if (this.nonPis && !this.nronpisUpdt) {
        this.nronpisImgempty = true;
        error++;
      }
      if (this.nonPisAccountNo && this.nonPisAccountNo.length < 11) {
        this.errorComp.ModalShow('Account No Min Length is 11');
        // this.toastr.error("Account No Min Length is 11");
        return;
      }
      if (this.nonPisAccountNo !== this.confirmnonPisAccountNo) {
        this.errorComp.ModalShow('Account No must be same');
        // this.toastr.error("Account No Min Length is 11");
        return;
      }
    }
    if (this.nro && this.nonPis) {
      if (this.nroAccountNo === this.nonPisAccountNo) {
        this.errorComp.ModalShow('Account No must be different');
        return;
      }
    }

    if (error === 0) {
      let url = 'DIY/DIYUpdtBank';

      let params = {
        NRE: this.nre ? 'Y' : 'N',
        NRO: this.nro ? 'Y' : 'N',
        PIS: this.pis ? 'Y' : 'N',
        NONPIS: this.nonPis ? 'Y' : 'N',
        NRE_AccountHolderName: this.nreAccountName ? this.nreAccountName : '',
        NRE_AC: this.nreAccountNo ? this.nreAccountNo : '',
        NRO_AC: this.nroAccountNo ? this.nroAccountNo : '',
        PIS_AC: this.pisAccountNo ? this.pisAccountNo : '',
        NONPIS_AC: this.nonPisAccountNo ? this.nonPisAccountNo : '',
        NRE_Bank: this.nreBank ? this.nreBank : '',
        NRE_MICR: this.nreMicr ? this.nreMicr : '',
        NRE_IFSC: this.nreIfscCode ? this.nreIfscCode : '',
        NRE_RBIRefNo: this.nreReferenceNo ? this.nreReferenceNo : '',
        NRO_Bank: this.nroBank ? this.nroBank : '',
        NRO_MICR: this.nroMicr ? this.nroMicr : '',
        NRO_IFSC: this.nroIfscCode ? this.nroIfscCode : '',
        NRO_RBIRefNo: this.nroReferenceNo ? this.nroReferenceNo : '',
        NROBankBranch: this.branchName,
        ConfirmNRO_AC: this.confirmnroAccountNo,
        PIS_Bank: this.pisBank ? this.pisBank : '',
        PIS_MICR: this.pisMicr ? this.pisMicr : '',
        PIS_IFSC: this.pisIfscCode ? this.pisIfscCode : '',
        PIS_RBIRefNo: this.pisReferenceNo ? this.pisReferenceNo : '',
        NONPIS_Bank: this.nonPisBank ? this.nonPisBank : '',
        NONPIS_MICR: this.nonPisMicr ? this.nonPisMicr : '',
        NONPIS_IFSC: this.nonPisIfscCode ? this.nonPisIfscCode : '',
        NONPIS_RBIRefNo: this.nonPisReferenceNo ? this.nonPisReferenceNo : '',
        NONPISNREBankBranch: this.branchName1,
        ConfirmNONPIS_AC: this.confirmnonPisAccountNo,
        Declarations: true,
        ExistingDemat: this.existingDemat,
        ReferenceNumber: this.erefNo,
      };

      let checkSum = this.erefNo + params.NRE + params.NONPIS;
      this.loader.start();
      this._http.httpPost(url, params, checkSum).subscribe({
        next: (data: any) => {
          this.loader.stop();
          let val = this.http.decryptUsingAES256(data.OutPut);
          if (val && val.IsSuccess) {
            // this.toastr.success(val.Success);
            this.router.navigate(['/segments'], { replaceUrl: true });
          } else {
            this.errorComp.ModalShow(val.Error || 'Something Went Wrong');
          }
        },
        error: (error) => {
          this.loader.stop();
          if (!window.navigator.onLine) {
            this.errorComp.ModalShow(
              'It appears that your internet connectivity is slow or please try again.',
            );
            // this.toastr.error("It appears that your internet connectivity is slow or please try again.");
          } else {
            this.errorComp.ModalShow(error.error.Message);
            // this.toastr.error(error.error.Message);
          }
        },
      });
    }
  }

  backStage() {
    this.router.navigate(['/fatca']);
  }

  validateInput(event: Event, bank: string): void {
    const inputElement = event.target as HTMLInputElement;
    // const validValue = inputElement.value.replace(/[^a-zA-Z]/g, '');
    const validValue = inputElement.value.replace(/[^a-zA-Z0-9\s\W]/g, '');
    inputElement.value = validValue;
    if (bank === 'branch1') {
      this.branchName = validValue;
    } else {
      this.branchName1 = validValue;
    }
  }
}
